"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Cookies = require("js-cookie");
var ITEM_REGION_OVERRIDE_COOKIE = 'itemRegionOverride';
var EVERYWHERE_ELSE_REGION_CODE = 'XX';
// exported for mocking
function refresh(href) {
    window.location.href = href;
}
exports.refresh = refresh;
function itemRegionConfigured() {
    var region = itemRegion();
    return region && region !== EVERYWHERE_ELSE_REGION_CODE;
}
exports.itemRegionConfigured = itemRegionConfigured;
function itemRegion() {
    return Cookies.get(ITEM_REGION_OVERRIDE_COOKIE) || '';
}
exports.itemRegion = itemRegion;
function changeStickyItemRegion(region, href) {
    var currentValue = itemRegion();
    if (currentValue !== region) {
        if (region.length === 0) {
            Cookies.remove(ITEM_REGION_OVERRIDE_COOKIE);
        }
        else {
            Cookies.set(ITEM_REGION_OVERRIDE_COOKIE, region);
        }
        refresh(href);
    }
}
exports.changeStickyItemRegion = changeStickyItemRegion;
//# sourceMappingURL=change_sticky_item_region.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/change_sticky_item_region.js
// module id = z3bF
// module chunks = 0 1 2 3 4 9 10 14 20